import React from "react";
import { Container, VideoContainer, Heading, VideoTitle } from "./styles";
import PropTypes from "prop-types";
import VideoElement from "../../Elements/Video";

const Video = ({ url, title, header, showInTabletAndMobile }) => {
	return (
		<Container showInTabletAndMobile={showInTabletAndMobile}>
			<Heading>{header} </Heading>
			<VideoContainer>
				<VideoElement url={url} />
				<VideoTitle>{title}</VideoTitle>
			</VideoContainer>
		</Container>
	);
};

Video.defaultProps = {
	url: "",
	header: "",
	title: "",
	showInTabletAndMobile: true,
};
Video.propType = {
	url: PropTypes.string,
	header: PropTypes.string,
	title: PropTypes.string,
	showInTabletAndMobile: PropTypes.bool,
};

export default Video;
